import * as rules from 'vee-validate/dist/rules';
import en from 'vee-validate/dist/locale/en.json';
import nl from 'vee-validate/dist/locale/nl.json';
import { extend, localize, setInteractionMode } from 'vee-validate';

export default function() {

    // Add rules
    for(let rule in rules) {
        extend(rule, rules[rule]);
    }

    // Add localizations
    localize({
        en,
        nl
    });

    // Validation mode
    setInteractionMode('eager');
}
